var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.304 16.0158C22.7904 16.3802 16 23.3976 16 32.0009C16 40.8375 23.1634 48.0009 32 48.0009C40.1295 48.0009 46.8429 41.9381 47.8652 34.0873H46.8561C45.8407 41.384 39.5763 47.0009 32 47.0009C23.7157 47.0009 17 40.2852 17 32.0009C17 23.9499 23.3428 17.3804 31.304 17.0168V16.0158Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 31",
    d: "M31.8047 15.9998V33.737",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 32",
    d: "M47.8651 34.1953L31.3044 34.1953",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M36 30V16C45.6 17.2444 48 25.8519 48 30H36Z",
    stroke: "#D91F05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaVolume);
export default __webpack_public_path__ + "static/media/metaVolume.70af7409b7c377bc553090b03912fc3d.svg";
export { ForwardRef as ReactComponent };